export const STATUS = {
  ACTIVE: "active",
  PENDING: "pending",
  DEACTIVATED: "deactivated",
};

export const LIMIT = [{
  label: "20",
  value: 20,
}, {
  label: "50",
  value: 50,
}, {
  label: "100",
  value: 100,
}];

export const USER_ROLES = {
  SYS_ADMIN: "SYS_ADMIN",
  SYS_USER: "SYS_USER",
  ADMIN: "ADMIN",
  MANAGER: "MANAGER",
  CASE_MANAGER: "CASE_MANAGER",
  CUSTOMER: "CUSTOMER",
  CLIENT: "CLIENT",
  ENTITY: "ENTITY",
};

export const CUSTOMIZATION_TYPES = {
  GLOBAL: "GLOBAL",
  NON_GLOBAL: "NON_GLOBAL",
};

export const TOKEN_TYPES = {
  INVITATION: "INVITATION",
  PASSWORD_RESET: "PASSWORD_RESET",
};

export const SUBSCRIPTION_TYPES = {
  ACTIVE: "active",
  TRIALING: "trialing",
  PAST_DUE: "past_due",
  CANCELLED: "canceled",
};